// Invoices action constants

export const REPORTS_INVOICES_PAGE_REQUEST = 'REPORTS_INVOICES_PAGE_REQUEST'
export const REPORTS_INVOICES_LIST_INVOICE_REQUEST = 'REPORTS_INVOICES_LIST_INVOICE_REQUEST'
export const REPORTS_INVOICES_SET_LIST_INVOICE = 'REPORTS_INVOICES_SET_LIST_INVOICE'

// Filter invoices constants
export const REPORTS_INVOICES_CHANGE_DATE = 'REPORTS_INVOICES_CHANGE_DATE'
export const REPORTS_INVOICES_CHANGE_OUTLET = 'REPORTS_INVOICES_CHANGE_OUTLET'
export const REPORTS_INVOICES_CHANGE_STATUS = 'REPORTS_INVOICES_CHANGE_STATUS'

// Receipt invoices constants
export const REPORTS_INVOICES_RECEIPT_REQUEST = 'REPORTS_INVOICES_RECEIPT_REQUEST'
export const REPORTS_INVOICES_SET_RECEIPT = 'REPORTS_INVOICES_SET_RECEIPT'

// Hide invoice receipt constants
export const REPORTS_INVOICES_HIDE_RECEIPT = 'REPORTS_INVOICES_HIDE_RECEIPT'

export const REPORTS_INVOICES_RESEND_EMAIL = 'REPORTS_INVOICES_RESEND_EMAIL'
// Record payment action constants
export const REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT = 'REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT'
export const REPORTS_INVOICES_RECORD_PAYMENT_REQUEST = 'REPORTS_INVOICES_RECORD_PAYMENT_REQUEST'
export const REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL = 'REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL'
export const REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL = 'REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL'

export const REPORTS_INVOICES_PRINT_RECEIPT_PDF = 'REPORTS_INVOICES_PRINT_RECEIPT_PDF'

export const REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL'
export const REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL'
export const REPORTS_INVOICES_ISSUE_REFUND_REQUEST = 'REPORTS_INVOICES_ISSUE_REFUND_REQUEST'

export const REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL'
export const REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL'
export const REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST = 'REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST'

export const REPORTS_INVOICES_EXPORT_INVOICES = 'REPORTS_INVOICES_EXPORT_INVOICES'

export const REPORTS_INVOICES_SET_OUTLETS = 'REPORTS_INVOICES_SET_OUTLETS'
export const REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT = 'REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT'
export const REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT = 'REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT'

export const REPORTS_INVOICES_SET_CURRENT_PAGE = 'REPORTS_INVOICES_SET_CURRENT_PAGE'
export const REPORTS_INVOICES_SET_TOTAL_PAGE = 'REPORTS_INVOICES_SET_TOTAL_PAGE'



// WEBPACK FOOTER //
// ./app/actions/reports/invoices/constants.js